'use client';
import React from 'react';
import { Section, SectionHeader, Container } from '@layout';
import { Card, EdgeFade } from '@ui';
import * as Icons from '@icons';
import { t as translate } from '@utils/translate';

export const defaultIconList = [
  Icons.IconReact,
  Icons.IconNextJs,
  Icons.IconHtml5,
  Icons.IconCss3,
  Icons.IconSass,
  Icons.IconJavaScript,
  Icons.IconTypeScript,
  Icons.IconVSCode,
  Icons.IconVSCodeCopilot,
  Icons.IconCursor,
  Icons.IconGitHub,
  Icons.IconUikit,
  Icons.IconSupabase,
  Icons.IconAWS,
  Icons.IconMobileScreen,
  Icons.IconTabletScreen,
  Icons.IconLaptop,
  Icons.IconDesktop,
  Icons.IconChrome,
  Icons.IconSafari,
  Icons.IconFirefox,
  Icons.IconEdge,
  Icons.IconToggleOn,
  Icons.IconLanguage,
  Icons.IconMoon,
  Icons.IconSun,
];

interface LogoRotatorProps {
  iconList?: React.ComponentType<{ className?: string }>[];
  className?: string;
  surface?: 'sf-1' | 'sf-2' | 'sf-3' | 'sf-4';
  /** Resolved by the page; defaults to English when omitted (e.g. Storybook). */
  locale?: 'en' | 'es';
}

const LogoRotator: React.FC<LogoRotatorProps> = ({
  iconList,
  className,
  surface = 'sf-1',
  locale = 'en',
}) => {
  // Use provided iconList or default
  const icons = [...(iconList || defaultIconList), ...(iconList || defaultIconList)];
  const pickString = (value: unknown, fallback: string): string =>
    typeof value === 'string' ? value : fallback;
  const title = pickString(translate('logo_rotator.heading', 'home', locale), 'Built with');
  const description = pickString(
    translate('logo_rotator.blurb', 'home', locale),
    'Technologies used on this site (not client logos).'
  );

  return (
    <Section className={['logos', surface, className].filter(Boolean).join(' ')}>
      <SectionHeader title={title} description={description} as='h2' />
      <Container>
        <div className='rotator-container'>
          <EdgeFade surface={surface} fades={['fade-left', 'fade-right']} />
          <div className='rotator-track'>
            {icons.map((Icon, idx) => (
              <Card key={idx} className='logo-rotator-card'>
                <Icon className='icon' />
              </Card>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default LogoRotator;
